const sections = [];
const offsets = [];

const getOffsetTop = element => {
    let offsetTop = 0;
    while(element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
}

const animateSec = (offsets, sections) => {
    var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    offsets.forEach((offsetH, index) => {
        if (offsetH <= scrollPosition + (screen.height - 120)) {
            sections[index].classList.add("animate__animated");
        }
    })
}

export const Scrollspy = (ele) => {    
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }  
    sections.push(ele);
    sections.forEach(section => {
        if(offsets.indexOf(getOffsetTop(section)) == -1){
            offsets.push(getOffsetTop(section));
        }
    });
    
    animateSec(offsets, sections);
    window.onscroll = () => {
        animateSec(offsets, sections);
    }
}
export default Scrollspy;